import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { UserListLabel } from "./UserListLabel/UserListLabel";

export const makeUserListLabel = (data: MakeLabelParams) => (
  <UserListLabel params={data} />
);
